import { ProductVariant } from "@omni/types/api/product/bff/shared/variants.model";
import { cn } from "@omni/utils/styles";

import { Dropdown } from "@/components/General/Dropdown/dropdown.component";

type Props = {
    variantGroup: ProductVariant[];
    sku: string;
};

const DropdownFallback = ({ variantGroup, sku }: Props) => {
    const activeOption = variantGroup.filter(
        (variant) => variant.sku === sku
    )[0].productTitle;

    return (
        <Dropdown
            className={cn("tw:w-full tw:mb-4")}
            isLabel={true}
            placement={"bottom"}
        >
            <Dropdown.Toggle
                color="gray"
                className={cn(
                    "tw:w-full tw:flex tw:justify-between tw:items-center tw:indent-3"
                )}
            >
                <Dropdown.Label>{activeOption}</Dropdown.Label>
                <Dropdown.Caret />
            </Dropdown.Toggle>
            <Dropdown.Menu className={cn("tw:w-full")}>
                {variantGroup.map((variant) => (
                    <Dropdown.Item
                        key={variant.productTitle}
                        tag="a"
                        href={variant.url}
                        label={variant.productTitle}
                    />
                ))}
            </Dropdown.Menu>
        </Dropdown>
    );
};

export default DropdownFallback;
